// src/components/layout.js
import React from "react";
import "../styles/global.css"; // Import your global CSS here

const Layout = ({ children }) => {
  return (
    <div>
      {/* You can add your header here if you like */}
      <main>{children}</main>
      {/* And your footer here if needed */}
    </div>
  );
};

export default Layout;
